// src/components/auth/ProtectedRoute.js - COMPLETE REPLACEMENT
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import styled from 'styled-components';

const LoadingContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(to bottom, #0B0B3B, #1A1A4C);
  color: #FFFFFF;
`;

const LoadingSpinner = styled.div`
  width: 40px;
  height: 40px;
  border: 3px solid rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  border-top-color: #800000;
  animation: spin 1s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

const ADMIN_EMAIL = 'kaleabteka@gmail.com';

const ProtectedRoute = ({ 
  children, 
  requireVerification = true, 
  adminOnly = false
}) => {
  const { user } = useAuth();

  // ✅ Allow both regular and anonymous users
  if (!user) {
    return <Navigate to="/" replace />;
  }

  // Admin check
  if (adminOnly && user.email?.toLowerCase() !== ADMIN_EMAIL) {
    return <Navigate to="/" replace />;
  }

  // ✅ UPDATED: Skip email verification for anonymous users
  if (requireVerification && !user.emailVerified && !user.isAnonymous) {
    return <Navigate to="/verify-email" replace />;
  }

  return children;
};

export default ProtectedRoute;